// Module
var code = "<div class=\"dialog\"> <h2 class=\"dialog-header\" v-if=\"$slots.header\"> <slot name=\"header\"></slot> </h2> <div class=\"dialog-content\" v-if=\"$slots.content\"> <slot name=\"content\"></slot> </div> <div class=\"dialog-footer\" v-if=\"$slots.footer\"> <slot name=\"footer\"></slot> </div> </div>";
// Exports
module.exports = code;